module.exports = __webpack_public_path__ + "static/media/plug.7b643fd1.svg";